import { createStore, combineReducers, applyMiddleware, Middleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import logger from 'redux-logger'
import { systemReducer } from "./system/reducers";
import { chatReducer } from "./chat/reducers"; 
import { accountRegisterReducer, accountLoginReducer, accountRecoverPasswordReducer } from "./account/reducers";
import { authOTPReducer } from "./authOTP/reducers";
import { themeReducer } from "./theme/reducers";

const rootReducer = combineReducers({
  system: systemReducer,
  chat: chatReducer,
  accountRegister: accountRegisterReducer,
  accountLogin: accountLoginReducer,
  accountRecoverPassword: accountRecoverPasswordReducer,
  authOTP: authOTPReducer,
  tenantTheme: themeReducer
});

export type AppState = ReturnType<typeof rootReducer>;

export default function configureStore() {
  const middlewares: Middleware[] = [thunkMiddleware];
  if (process.env.NODE_ENV === `development`) {
    middlewares.push(logger);
  }
  const middleWareEnhancer = applyMiddleware(...middlewares);

  const store = createStore(
    rootReducer,
    composeWithDevTools(middleWareEnhancer)
  );

  return store;
}



export interface RootState {
}
